import React, { useState } from 'react'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import { Button, Grid } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { Modal } from 'asterX-UI/Modals'
import TaskCard from 'components/Desktop/Tasks/TaskCard'
import CreateTaskComponent from 'components/Desktop/Tasks/CreateTaskComponent'
import TaskSwitcher from 'components/Desktop/Tasks/TaskSwitcher'
import { PAYMENT } from 'constants/deals'

const TaskTab = ({}) => {
  const {
    workListViewStore,
    workListViewStoreFunc: { getTaskList, onSetIsClosedTasks }
  } = useWorkListViewMnStore()
  const { sale } = workListViewStore
  const [open, setOpen] = useState(false)
  const onOpenTask = () => {
    setOpen(prevState => !prevState)
    getTaskList()
  }
  return (
    <Grid item container xs={12} md={12} spacing={2}>
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: 'flex'
        }}
      >
        <TaskSwitcher
          style={{ width: '100%' }}
          isClosedTasks={workListViewStore.isClosedTasks}
          onChange={onSetIsClosedTasks}
        />

        <Button
          color={'primary'}
          variant={'contained'}
          size={'small'}
          onClick={onOpenTask}
        >
          <AddIcon />
        </Button>
      </Grid>
      <Grid item xs={12} md={12}>
        {workListViewStore.taskList?.length > 0
          ? workListViewStore.taskList.map((task, index) => (
              <TaskCard
                task={task}
                key={`task_${index}`}
                isClosedTasks={workListViewStore.isClosedTasks}
              />
            ))
          : 'Нет данных'}
      </Grid>
      <Modal open={open} fullWidth>
        <CreateTaskComponent
          saleId={sale?.id}
          globalId={sale?.globalId}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          client={{
            contactFullname: `${sale?.client?.firstName || ''} ${
              sale?.client?.lastName || ''
            }`,
            phoneNumber: sale?.client?.phoneNumber || '',
            additionalPhoneNumber: sale?.client?.additionalPhoneNumber || ''
          }}
          onClose={onOpenTask}
          onSuccess={onOpenTask}
        />
      </Modal>
    </Grid>
  )
}
export default TaskTab
